import { pickT } from "@repo/shared";
import { T } from "./order-product-name.i18n";

/**
 * Display name of an order's instrument from its frozen i18n map (QL-203 —
 * orders carry no product reference), falling back to the ISIN for nameless
 * instruments (QL-283 — ISIN-only unmatchable switch sources freeze an empty
 * name map). Shared by the Orders tab and the order detail dialog.
 */
export function getOrderProductName(
  nameI18n: Record<string, string> | null,
  lang: string,
  isinFallback?: string | null,
): string {
  if (!nameI18n) return isinFallback || "—";
  return (
    nameI18n[lang] ||
    nameI18n.en_GB ||
    nameI18n.en ||
    Object.values(nameI18n)[0] ||
    isinFallback ||
    "—"
  );
}

/**
 * Order and holding amounts are whole numbers (QL-547), the same on the
 * Orders tab, the order detail dialog, the Recurring orders table and the
 * Accounts tab. Prices and weights keep their decimals and do not use this.
 * Takes the regional formatter so the thousands separator follows the user.
 */
/** "1 unit" / "6 units", in the given language. */
export function formatUnits(n: number, lang: string): string {
  const t = pickT(T, lang);
  return `${n} ${n === 1 ? t.unit : t.units}`;
}

export function formatWholeAmount(
  value: number,
  formatNumber: (v: number, opts?: { maximumFractionDigits?: number }) => string,
): string {
  return formatNumber(value, { maximumFractionDigits: 0 });
}
